import { instance } from "libs/api";

import { ApiRoutesDeliveryFees } from "../../constants";
import { ParcelSizes } from "../../financial.types";

export const requestParcelSizes = async (): Promise<{
  parcelSize: ParcelSizes;
}> => {
  return await instance.get(ApiRoutesDeliveryFees.ParcelSizes);
};
